export enum LabelInfo {
    Text = 'string',
    Currency = 'currency',
    Frequency = 'frequency',
}
